import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, } from 'react-bootstrap';
import IconButton from 'components/common/IconButton';
import Flex from 'components/common/Flex';
import moment from 'moment-timezone';

const OneDPSBandeau = ({
    dps,
    setPageNeedsRefresh,
}) => {
    const navigate = useNavigate();

    return (<>

        <Card className="mb-3">
            <Card.Header className="d-flex flex-between-center">
                <IconButton
                    onClick={() => navigate(-1)}
                    variant="falcon-default"
                    size="sm"
                    icon="arrow-left"
                />
                <h5><small>{moment(dps.debutDPS).format('dddd DD/MM')}</small> {dps.libelleDPS}</h5>
                <Flex>

                    <IconButton
                        variant="outline-primary"
                        size="sm"
                        className="me-2 d-none d-md-inline-block"
                        icon="retweet"
                        onClick={()=>{setPageNeedsRefresh(true)}}
                    >
                        Rafraichir
                    </IconButton>
                </Flex>
            </Card.Header>
        </Card>
    </>);
    
};

OneDPSBandeau.propTypes = {};

export default OneDPSBandeau;
